import { render, staticRenderFns } from "./combinedMedica.vue?vue&type=template&id=2cb7476e&scoped=true&"
import script from "./combinedMedica.vue?vue&type=script&lang=js&"
export * from "./combinedMedica.vue?vue&type=script&lang=js&"
import style0 from "./combinedMedica.vue?vue&type=style&index=0&id=2cb7476e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7476e",
  null
  
)

export default component.exports